import styles from './ProductCardHeader.module.scss';
import React from 'react';
import { Content, Heading, Image } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const ProductCardHeader = ({ title, image, type, tarifSubline }) => (
  <div className={classNames(styles.container, styles[type])}>
    <div className={styles.heading}>
      <Content noSpacing />
      <Heading as="h2" className={styles.title} noSpacing size="h5">
        {title}
      </Heading>
      <Content noSpacing>{tarifSubline}</Content>
    </div>
    {!!image && <Image alt="" className={styles.productIcon} src={image} />}
  </div>
);

export default ProductCardHeader;
